// @ vendors
const get = require('lodash/object/get');

// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { getLanguage } = require('core/i18n').i18n;

// @ constants
const actionTypes = require('constants/actionTypes');
const { CAMPAIGN_PRICING_CHANNEL } = require('constants/index');

function reset() {
    return {
        type: actionTypes.HIRE_INFORMATION_RESET
    };
}

const hireInformationRequest = () => ({
    type: actionTypes.HIRE_INFORMATION_REQUEST
});

const hireInformationSucess = information => ({
    type: actionTypes.HIRE_INFORMATION_SUCCESS,
    payload: {
        information
    }
});

const hireInformationFailure = error => ({
    type: actionTypes.HIRE_INFORMATION_FAILURE,
    payload: {
        error
    }
});

const getHireInformation = contractId => (dispatch, getState) => {
 
    if (!getState().hireInformation.get('isFetching')) {
        const language = getLanguage().toUpperCase();
         dispatch(hireInformationRequest());
        return APIGet({
                dispatch,
                endpoint: 'campaignEngine',
                url: `${apiURLBuilder.getURL('campaignEngine')}/default/${language}/${contractId}/1`
            })
            .then(response => {
                dispatch(hireInformationSucess(get(response, '[0].body.value')));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(hireInformationFailure(response.error));
                } else {
                    throw response;
                }
            });

    }
};

const getHireInformationWithPricing = location => (dispatch, getState) => {
     if (!getState().hireInformation.get('isFetching')) {
        const data = {
            query: {
                lang: getLanguage().toUpperCase(),
                location: location,
                type: CAMPAIGN_PRICING_CHANNEL
            }
        }

        return new Promise(() => {
            dispatch(hireInformationRequest());
            APIPost({
                dispatch,
                endpoint: 'campaignWithPricing',
                params: data
            })
            .then(response => {
                const htmlBody = response.nodes && response.nodes[0] && response.nodes[0].body && response.nodes[0].body[0];
                dispatch(hireInformationSucess(htmlBody && htmlBody.value));
            })
            .catch(response => {
                if (response.error) {
                    dispatch(hireInformationFailure(response.error));
                } else {
                    throw response;
                }
            });
        });
    }
};

module.exports = {
    getHireInformation,
    getHireInformationWithPricing,
    reset
};
